module.exports = __webpack_public_path__ + "static/media/error-page-banner.803f176f.svg";